import script from "./AddMedicationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddMedicationForm.vue?vue&type=script&setup=true&lang=ts"

import "./AddMedicationForm.vue?vue&type=style&index=0&id=4f548125&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f548125"]])

export default __exports__